<template>
  <div id="locationServiceContactForm" class="col-12 bg-white rounded p-4">
    <validation-observer
      ref="locationServiceContactForm"
      v-slot="{}"
      tag="form"
    >
      <div class="row">
        <div class="col-12 mt-2">
          <icon-view
            class="mr-2 rounded-circle"
            :icon="model.id ? 'fas fa-edit' : 'fas fa-plus'"
            icon-background="white"
            icon-color="#2EB882"
            icon-size="14px"
            :title="title"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoName"
            rules="required"
          >
            <custom-input
              v-model="model.nameFirst"
              :custom-error-msg="'El nombre es requerido.'"
              :error="errors[0]"
              label="Nombre:"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <custom-input
            v-model="model.nameInitial"
            label="Inicial:"
            maxlength="1"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoPaternalLastName"
            rules="required"
          >
            <custom-input
              v-model="model.nameLastPaternal"
              :custom-error-msg="'El apellido paterno es requerido.'"
              :error="errors[0]"
              label="Apellido Paterno:"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <custom-input
            v-model="model.nameLastMaternal"
            label="Apellido Materno:"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoDepartment"
          >
            <custom-input
              v-model="model.department"
              :custom-error-msg="'El departamento es requerido.'"
              :error="errors[0]"
              label="Departamento:"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoPosicion"
          >
            <custom-input
              v-model="model.position"
              :custom-error-msg="'La posicion es requerida.'"
              :error="errors[0]"
              label="Posición:"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors, failedRules }"
            name="primaryContactInfoEmail"
            rules="email"
          >
            <custom-input
              v-model="model.email"
              :custom-error-msg="
                failedRules['email']
                  ? 'El correo electrónico no es válido.'
                  : ''
              "
              :error="errors[0]"
              label="Correo Electrónico:"
              type="email"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="cellPhone"
            v-slot="{ errors }"
            name="cellPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Celular:</label>
            <custom-input
              v-model="model.cellPhone"
              :custom-error-msg="'El teléfono celular es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              placeholder="(___)___-____"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="workPhone"
            v-slot="{ errors }"
            name="workPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Trabajo:</label>
            <custom-input
              v-model="model.workPhone"
              :custom-error-msg="'El teléfono trabajo es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              placeholder="(___)___-____"
              @input="validateField"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            ref="fax"
            v-slot="{ errors }"
            name="fax"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Fax:</label>
            <custom-input
              v-model="model.fax"
              :custom-error-msg="'El fax es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              placeholder="(___)___-____"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="homePhone"
            v-slot="{ errors }"
            name="homePhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Hogar:</label>
            <custom-input
              v-model="model.homePhone"
              :custom-error-msg="'El teléfono del hogar es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              placeholder="(___)___-____"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <custom-input
            id="workPhoneExt"
            v-model="model.workPhoneExt"
            label="Ext:"
            :mask-type="'PhoneExt'"
            placeholder="_____"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mr-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                :i="model.id ? 'fas fa-save fa-lg' : 'fas fa-file-plus fa-lg'"
                :text="model.id ? 'Guardar' : 'Añadir'"
                variant="success"
                @click="submitForm()"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  addLocationServiceContact as _addLocationServiceContact,
  editLocationServiceContact as _editLocationServiceContact,
} from '@/services/provider/location-service.api.js';

export default {
  name: 'AddLocationServiceContact',
  components: {
    ValidationProvider,
    CustomInput,
    ActionButton,
    IconView,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    locationId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    model: {
      id: null,
      isPrimaryContactFlag: null,
      nameFirst: null,
      nameInitial: null,
      nameLastPaternal: null,
      nameLastMaternal: null,
      department: null,
      position: null,
      email: null,
      homePhone: null,
      cellPhone: null,
      fax: null,
      workPhone: null,
      workPhoneExt: null,
    },
  }),
  mounted() {
    const scrollDiv = document.getElementById('locationServiceContactForm')
      .offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: 'smooth' });

    this.model = {
      id: this.value?.id,
      isPrimaryContactFlag: this.value?.isPrimaryContactFlag,
      nameFirst: this.value?.name,
      nameInitial: this.value?.initial,
      nameLastPaternal: this.value?.lastName,
      nameLastMaternal: this.value?.secondSurname,
      department: this.value?.workDepartmentName,
      position: this.value?.workPositionTitle,
      email: this.value?.email,
      cellPhone: this.value?.telephoneMobileNo,
      workPhone: this.value?.telephoneWorkNo,
      workPhoneExt: this.value?.workPhoneExt,
      fax: this.value?.telephoneWorkFaxNo,
      homePhone: this.value?.telephoneHomeNo,
    };
  },
  computed: {
    title() {
      return this.model.id ? 'Editar Contacto' : 'Añadir Contacto';
    },
    isSomePhoneFilledUp() {
      const cellPhone = Boolean(this.model.cellPhone);
      const workPhone = Boolean(this.model.workPhone);
      const fax = Boolean(this.model.fax);
      const homePhone = Boolean(this.model.homePhone);
      return cellPhone || workPhone || fax || homePhone;
    },
  },
  methods: {
    validateField() {
      if (!this.isSomePhoneFilledUp) {
        this.$refs['cellPhone'].reset();
        this.$refs['workPhone'].reset();
        this.$refs['fax'].reset();
        this.$refs['homePhone'].reset();
      }
    },
    async submitForm() {
      const isFormValid = await this.$refs.locationServiceContactForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información de contacto solicitada.',
          'error'
        );
        return;
      }
      if (this.model.id) {
        await this.updateLocationServiceContact();
      } else {
        await this.addLocationServiceContact();
      }
    },
    async addLocationServiceContact() {
      const { data } = await _addLocationServiceContact(
        { ...this.model },
        this.locationId
      ).catch((error) => {
        this.ShowToast('Alerta', `${error.response.data.message}`, 'error');
        return;
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'El contacto ha sido añadida exitosamente.',
          'success'
        );

      this.$emit('save', data);
    },
    async updateLocationServiceContact() {
      const { data } = await _editLocationServiceContact(
        this.model,
        this.locationId
      ).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return;
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'El contacto sido actualizado exitosamente.',
          'success'
        );

      this.$emit('save', data);
    },
    limitCharacters(event, $val) {
      if ($val.length > 6) {
        return event.preventDefault();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.plus-icon {
  padding: 3px 4px;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
}
</style>
